import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface HeaderSectionProps {
  isEditing: boolean;
  hasIntegration: boolean;
  isSubmitting: boolean;
  validateConfig: () => boolean;
  onSubmit: (e?: React.FormEvent) => void;
  onEdit: () => void;
  onCancel: () => void;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  isEditing,
  hasIntegration,
  onEdit,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4,
        pt: 2,
      }}
    >
      <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
        AccuLynx Integration Setup
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, ml: 4, mt: 1.5 }}>
        {hasIntegration && !isEditing && (
          <>
            <Button
              variant="outlined"
              onClick={() => navigate('/settings/integrations')}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onEdit}
              startIcon={<EditIcon />}
            >
              Edit Configuration
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};
